<div bsModal
     #staticModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">X</span>
        </button>
        <storever-header-modal [title]="'ORDER_LIST_ADD_PLAYER'" [icon]="'fa-hdd'"></storever-header-modal>
      </div>
      <div class="width-form">
        <storever-header-subtitle [datas]="[
              {icon: 'fa-user', title: 'GENERIC_CLIENT', name: (client$|async)?.name},
              {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: (site$|async)?.displayName}
            ]
            "></storever-header-subtitle>
      </div>
      <div class="modal-body">
        <div class="portlet-body" style="padding: 15px">

          <form [formGroup]="myForm" style="width:100%">
<!--            productId{{productId}}-->
            <div *ngIf="(productId === 24 || productId === 27) && isDXP ; else addPlayer">

              <storever-element-group
                [icon]="'fa-address-book'"
                [title]="'none'"
                [config]="formConfigAdoption.config"
                [form]="formAdoption">
              </storever-element-group>
            </div>
            <ng-template #addPlayer>
              <storever-element-group
                [icon]="'fa-address-book'"
                [title]="'none'"
                [config]="formConfig.groupConfigs[0].config"
                [form]="myForm">
              </storever-element-group>
            </ng-template>
          </form>
          <div *ngIf="isDXP && productId !== 24 &&  productId !== 27">
            <storever-element-group
              [icon]="'fa-address-book'"
              [title]="'none'"
              [config]="conceptFormConfig.config"
              [form]="conceptForm">
            </storever-element-group>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button *ngIf="(productId !== 24 && productId !== 27)" type="button" class="btn btn-primary" [disabled]="!myForm.get('id').value"
                (click)="send(myForm.get('id').value , formAdoption.value)"> {{'GENERIC_ASSIGN' | translate:locale.language}} </button>
        <button *ngIf="productId === 27" type="button" class="btn btn-primary" [disabled]="!formAdoption.get(['bsnProductModel' , 'name']).value"
                (click)="send(myForm.get('id').value , formAdoption.value)"> {{'GENERIC_ASSIGN' | translate:locale.language}} </button>
        <button *ngIf="productId === 24" type="button" class="btn btn-primary" [disabled]="!formAdoption.get(['code']).value"
                (click)="send(myForm.get('id').value , formAdoption.value)"> {{'GENERIC_ASSIGN' | translate:locale.language}} </button>
      </div>
    </div>
  </div>
</div>


